import {ActionContext, ActionTree, GetterTree, Module, MutationTree} from "vuex";
import pillUseCases from "../../../../domain/usecase/impl/pill/pillUseCases";

import {Pill} from "../../../../domain/entities/pill";

class PillState {
  pill: Pill = new Pill();
  pills: Pill[] = [];
  numberOfPages = 0;
}

const state = new PillState();

const mutations: MutationTree<PillState> = {
  SET_PILL(state: PillState, pill: Pill): void {
    state.pill = pill;
  },
  SET_PILLS(state: PillState, pills: Pill[]): void {
    state.pills = pills;
  }
};

const actions: ActionTree<PillState, PillState> = {
  /** Lists an array with all the pills in the app. */
  async list({ commit }: ActionContext<PillState, PillState>): Promise<void> {
    try {
      const response: Pill[] = await pillUseCases.list();
      commit("SET_PILLS", response);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  /** Gets a pill.
   * @param commit
   * @param id ID of the pill. */
  async get(
      { commit }: ActionContext<PillState, PillState>,
      id: number
  ): Promise<void> {
    try {
      const response: Pill = await pillUseCases.get(id);
      commit("SET_PILL", response);
    } catch (e) {
      commit("SET_PILL", new Pill());
      console.log(e);
      throw e;
    }
  },

  async watch(
      { commit }: ActionContext<PillState, PillState>,
      id: number
  ): Promise<void> {
    try {
      return await pillUseCases.watch(id);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
};

const getters: GetterTree<PillState, PillState> = {
  pill: (state: PillState): Pill => state.pill,
  pills: (state: PillState): Pill[] => state.pills
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} as Module<PillState, PillState>;
